function isString(value) {
    return typeof value === 'string';
}
function isRegExp(value) {
    return value instanceof RegExp;
}
export function isMatchingPattern(value, pattern, requireExactStringMatch = false) {
    if (!isString(value)) {
        return false;
    }
    if (isRegExp(pattern)) {
        return pattern.test(value);
    }
    if (isString(pattern)) {
        return requireExactStringMatch
            ? value === pattern
            : value.includes(pattern);
    }
    return false;
}
export function stringMatchesSomePattern(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern) => isMatchingPattern(testString, pattern, requireExactStringMatch));
}
//# sourceMappingURL=string.js.map